import * as React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import { withStyles, WithStyles, Theme } from "@material-ui/core/styles";
import { Card, CardHeader, CardContent } from "@material-ui/core";
import ContentCircularProgress from "src/common/Components/general/ContentCircularProgress";

interface LoadingCardProps extends WithStyles<typeof styles> {
  title?: string;
}

class LoadingCard extends React.PureComponent<LoadingCardProps> {
  constructor(props: LoadingCardProps) {
    super(props);
  }

  render() {
    const { classes, title } = this.props;
    return (
      <Card>
        <CardHeader title={title} />
        <CardContent className={classes.content}>
          <ContentCircularProgress />
        </CardContent>
      </Card>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    content: {
      display: "flex",
      justifyContent: "center"
    }
  });

export default withStyles(styles)(LoadingCard);
